import {Component} from "../../../gvf/js/component";

export class CampaignUrlResults extends Component{
    ready(){
        this.findMember("copy").click(
            (ev)=>{
                const urlInput = $(ev.currentTarget).closest(this.scope+"__item").find(this.scope+"__url").get(0);
                urlInput.select();
                urlInput.setSelectionRange(0, 99999);
                document.execCommand("copy");
            }
        );
    }
}

